// extracted by mini-css-extract-plugin
module.exports = {"tag":"shop-price-tag_tag__FPSxg","amount":"shop-price-tag_amount___J4NS","badge":"shop-price-tag_badge__Wgpe2","spin":"shop-price-tag_spin__PKRML"};